import { SearchFilter } from "./container/SearchFilter";
import { SearchTable } from "./container/SearchTable";
import useGoToNavigation from '../../../../util/useGotoNavigation';
import { useReadTopicType } from "../hooks";
import { useUser } from "../../../../util/userContext/UserContext";
import { useEffect, useState } from "react";
import { useGetCustomerSupportFaqReadFaqHeader } from "../hooks/useGetCustomerSupportFaqReadFaqHeader";
import { useGetCustomerSupportFaqReadFaqList } from "../hooks/useGetCustomerSupportFaqReadFaqList";
import { usePostCustomerSupportFaqSaveFaqHeader } from "../hooks/usePostCustomerSupportFaqSaveFaqHeader";
import { useReadFaqDetail } from "../hooks/useReadFaqDetail";
import { useModal } from "../../../../hooks";
import { useReadFaqDetail2 } from "../hooks/useReadFaqDetail2";
import { useGetCustomerSupportFaqReadFaqList2 } from "../hooks/useGetCustomerSupportFaqReadFaqList2";

export const FaqList = () => {
    const { goToNavigation } = useGoToNavigation();
    const { user } = useUser();
    const { handleModal } = useModal();

    const [buttonMode, setButtonMode] = useState<boolean>(false);
    const [selectTopicType, setSelectTopicType] = useState<number | null>(null);
    const [selectTopicType2, setSelectTopicType2] = useState<number | null>(null);
    const [selectFaqId, setSelectFaqId] = useState<string | null>(null);
    const [selectFaqId2, setSelectFaqId2] = useState<string | null>(null);
    const { data: topicTypeData } = useReadTopicType();
    const { data: getCustomerSupportFaqReadFaqHeader } = useGetCustomerSupportFaqReadFaqHeader();
    const { data: getCustomerSupportFaqReadFaqList } = useGetCustomerSupportFaqReadFaqList(selectTopicType);
    const { data: getCustomerSupportFaqReadFaqList2 } = useGetCustomerSupportFaqReadFaqList2(selectTopicType2);
    const { data: readFaqDetail } = useReadFaqDetail({ id: selectFaqId ?? null });
    const { data: readFaqDetail2 } = useReadFaqDetail2({ id: selectFaqId2 ?? null });
    const { mutate: postCustomerSupportFaqSaveFaqHeader } = usePostCustomerSupportFaqSaveFaqHeader();

    const [isFirstLoad, setIsFirstLoad] = useState(true);

    const [initialTopicType, setInitialTopicType] = useState<number | null>(null);
    const [initialTopicType2, setInitialTopicType2] = useState<number | null>(null);
    const [initialFaqId, setInitialFaqId] = useState<string | null>(null);
    const [initialFaqId2, setInitialFaqId2] = useState<string | null>(null);

    // 초기 header 정보로 topicType, faqId 설정
    useEffect(() => {
        if (!getCustomerSupportFaqReadFaqHeader) return;

        const topicType = Number(getCustomerSupportFaqReadFaqHeader?.topicTypeIdx);
        const topicType2 = Number(getCustomerSupportFaqReadFaqHeader?.topicTypeIdx2);
        const faqId = getCustomerSupportFaqReadFaqHeader.faqId;
        const faqId2 = getCustomerSupportFaqReadFaqHeader.faqId2;

        setSelectTopicType(topicType);
        setSelectTopicType2(topicType2);
        setSelectFaqId(faqId);
        setSelectFaqId2(faqId2);
        setIsFirstLoad(true); // 초기 플래그는 true
    }, [getCustomerSupportFaqReadFaqHeader]);

    // 첫 번째 topicType 변경 시 FAQ 리스트 로드 후 첫 번째 항목 자동 선택
useEffect(() => {
    if (getCustomerSupportFaqReadFaqList?.length > 0) {
        // topicType이 변경된 후 selectFaqId가 현재 리스트에 존재하지 않으면 첫 번째로 세팅
        const exists = getCustomerSupportFaqReadFaqList.some(
            (item: any) => item.faqId === selectFaqId
        );
        if (!exists) {
            setSelectFaqId(getCustomerSupportFaqReadFaqList[0].faqId);
        }
    } else {
        // 리스트가 없을 경우 null 처리
        setSelectFaqId(null);
    }
}, [getCustomerSupportFaqReadFaqList, selectTopicType]);

// 두 번째 topicType 변경 시 FAQ 리스트 로드 후 첫 번째 항목 자동 선택
useEffect(() => {
    if (getCustomerSupportFaqReadFaqList2?.length > 0) {
        const exists2 = getCustomerSupportFaqReadFaqList2.some(
            (item: any) => item.faqId === selectFaqId2
        );
        if (!exists2) {
            setSelectFaqId2(getCustomerSupportFaqReadFaqList2[0].faqId);
        }
    } else {
        setSelectFaqId2(null);
    }
}, [getCustomerSupportFaqReadFaqList2, selectTopicType2]);
    // faqId를 header에서 미리 받아온 값으로 강제로 지정하고 싶을 경우, 별도 조건으로 처리해야 함 (선택적)
    // 또는 초기 로딩 상태를 구분해서 첫 로딩 시에만 header 값 반영

    const handleGoToFaqDetail = () => goToNavigation(`support/faq/detail/${getCustomerSupportFaqReadFaqHeader?.faqId}`, {}, false);
    const handleGoToFaqDetail2 = () => goToNavigation(`support/faq/detail/${getCustomerSupportFaqReadFaqHeader?.faqId2}`, {}, false);

    const handleModify = () => {
        if (getCustomerSupportFaqReadFaqList?.length === 0) {
            handleModal({
                isOpen: true,
                contents: "FaQ 가 존재하지 않습니다. 1번째 요소",
                type: 'alert',
            });
            return;
        }
        if (getCustomerSupportFaqReadFaqList2?.length === 0) {
            handleModal({
                isOpen: true,
                contents: "FaQ 가 존재하지 않습니다. 2번째 요소",
                type: 'alert',
            });
            return;
        }

        console.log("저장 클릭 : ", {
            userId: user?.userId,
            faqId: selectFaqId,
            faqId2: selectFaqId2,
            deleteFlag: readFaqDetail?.deleteFlag
        })
        postCustomerSupportFaqSaveFaqHeader({
            userId: readFaqDetail?.userId,
            faqId: readFaqDetail?.faqId,
            faqId2: readFaqDetail2?.faqId,
            deleteFlag: readFaqDetail?.deleteFlag
        }, {
            onSuccess: (res) => {
                if (res?.code === '0000') setButtonMode(false);
            }
        });
    }

    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">FAQ 정보</h3>
                    <div className="filter_toolbar">
                        {user?.authority?.faqWriteYn === 'Y' && <>
                            {buttonMode ?
                                <>
                                    <button className="btn btn-primary" onClick={handleModify}>저장</button>
                                    <button
                                        className="btn btn-dark w-80px"
                                        onClick={() => {
                                            // 원래 값으로 되돌림
                                            setSelectTopicType(initialTopicType);
                                            setSelectTopicType2(initialTopicType2);
                                            setSelectFaqId(initialFaqId);
                                            setSelectFaqId2(initialFaqId2);
                                            setButtonMode(false);
                                        }}
                                    >
                                        취소
                                    </button>
                                </>
                                :
                                <button className="btn btn-primary" onClick={() => {
                                    // 현재 상태값을 복사해서 저장
                                    setInitialTopicType(selectTopicType);
                                    setInitialTopicType2(selectTopicType2);
                                    setInitialFaqId(selectFaqId);
                                    setInitialFaqId2(selectFaqId2);
                                    setButtonMode(true);
                                }}>
                                    수정하기
                                </button>}
                        </>}
                    </div>
                </div>
                <div className="faq_box_outer">
                    <div className="faq_box box1 clickable"
                        onClick={() => goToNavigation('support/qna/list', {}, false)}>
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/icon_faq1.png"}
                            alt=""
                        />
                        <div className="text">찾는 답변이 없다면?</div>
                    </div>
                    <div className="faq_box box2" >
                        <div className="left">
                            <h5>질문 바로가기</h5>
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/icon_qna.png"}
                                alt=""
                            />
                        </div>

                        {buttonMode === true ? (

                            <div className="right">
                                <div style={{ display: 'flex', justifyContent: 'center', gap: '5px' }}>
                                    <select
                                        className="form-select w-50"
                                        value={selectTopicType !== null ? String(selectTopicType) : ''}
                                        onChange={(e) => {
                                            const selectedIdx = Number(e.target.value);
                                            if (!isNaN(selectedIdx)) {
                                                setSelectTopicType(selectedIdx);
                                            }
                                        }}
                                        style={{ marginTop: '10px' }}
                                    >
                                        {topicTypeData?.map((item: any) => (
                                            <option value={item.idx}>
                                                {item.codeEntriesName}
                                            </option>
                                        ))}
                                    </select>
                                    <select
                                        className="form-select"
                                        value={selectFaqId ?? ''}
                                        onChange={(e) => {
                                            const selectedFaqId = e.target.value;
                                            setSelectFaqId(selectedFaqId);
                                        }}
                                        disabled={!getCustomerSupportFaqReadFaqList || getCustomerSupportFaqReadFaqList.length === 0}
                                    >
                                        {getCustomerSupportFaqReadFaqList?.length ? (
                                            getCustomerSupportFaqReadFaqList.map((item: any) => (
                                                <option key={item.faqId} value={item.faqId}>
                                                    {item.title}
                                                </option>
                                            ))
                                        ) : (
                                            <option disabled>선택 가능한 항목이 없습니다</option>
                                        )}
                                    </select>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center', gap: '5px' }}>
                                    <select
                                        className="form-select w-50"
                                        value={selectTopicType2 !== null ? String(selectTopicType2) : ''}
                                        onChange={(e) => {
                                            const selectedIdx = Number(e.target.value);
                                            if (!isNaN(selectedIdx)) {
                                                setSelectTopicType2(selectedIdx);
                                            }
                                        }}
                                        style={{ marginTop: '10px' }}
                                    >
                                        {topicTypeData?.map((item: any) => (
                                            <option value={item.idx}>
                                                {item.codeEntriesName}
                                            </option>
                                        ))}
                                    </select>
                                    <select
                                        className="form-select"
                                        value={selectFaqId2 ?? ''}
                                        onChange={(e) => {
                                            const selectedFaqId2 = e.target.value;
                                            setSelectFaqId2(selectedFaqId2);
                                        }}
                                        disabled={!getCustomerSupportFaqReadFaqList2 || getCustomerSupportFaqReadFaqList2.length === 0}
                                    >
                                        {getCustomerSupportFaqReadFaqList2?.length ? (
                                            getCustomerSupportFaqReadFaqList2.map((item: any) => (
                                                <option key={item.faqId} value={item.faqId}>
                                                    {item.title}
                                                </option>
                                            ))
                                        ) : (
                                            <option disabled>선택 가능한 항목이 없습니다</option>
                                        )}
                                    </select>
                                </div>
                            </div>
                        ) : (
                            <div className="right" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                                <div style={{ marginBottom: '10px', cursor: 'pointer' }} onClick={() => handleGoToFaqDetail()}>
                                    {readFaqDetail?.title}
                                </div>
                                <div className="text" style={{ cursor: 'pointer' }} onClick={() => handleGoToFaqDetail2()}>
                                    {readFaqDetail2?.title}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="faq_box box3">
                        <div className="left">
                            <h5>MDS테크로 문의하세요</h5>
                            <ul>
                                <li>
                                    <img
                                        src={
                                            process.env.PUBLIC_URL + "/assets/images/icon_faq31.png"
                                        }
                                        alt=""
                                    />
                                    es@mdstech.co.kr
                                </li>
                                <li>
                                    <img
                                        src={
                                            process.env.PUBLIC_URL + "/assets/images/icon_faq32.png"
                                        }
                                        alt=""
                                    />
                                    031-602-2048
                                </li>
                            </ul>
                        </div>
                        <div className="right">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/icon_faq3.png"}
                                alt=""
                            />
                        </div>
                    </div>
                </div>
            </div >
            <SearchFilter />
            <SearchTable />
        </>
    );
};
